/* ==========================================================================
   Wishwire · theme.js
   Sin dependencias. Todo funciona sin JS (formularios nativos de Shopify);
   este archivo solo mejora la experiencia: variantes, galería, carrito lateral,
   barra fija de compra y animaciones suaves.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    document.body.classList.contains('no-motion');

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '{{amount}} €';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }

  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().catch(function () {
        throw new Error(theme.strings.cartError);
      }).then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || theme.strings.cartError);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- Barra superior: rota los mensajes ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Menú móvil ---------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') menu.removeAttribute('open');
    });
    document.addEventListener('click', function (e) {
      if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
    });
  }

  /* ---------- Galería ---------- */
  function initGallery(gallery) {
    var track = $('[data-gallery-track]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    if (!track) return null;

    function setActive(id) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }

    function goTo(id, smooth) {
      var slide = $('[data-media-id="' + id + '"]', track);
      if (!slide) return;
      var left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: left, behavior: smooth && !reduceMotion && !document.hidden ? 'smooth' : 'instant' });
      setActive(id);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(t.getAttribute('data-thumb'), true); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        var slide = track.children[index];
        if (slide) setActive(slide.getAttribute('data-media-id'));
        ticking = false;
      });
    }, { passive: true });

    return { goTo: goTo };
  }

  /* ---------- Bloque de compra ---------- */
  function initBuyBox(box) {
    var form = $('form.buy-box__form', box);
    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var jsonEl = $('[data-variants-json]', box);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }
    var picker = $('[data-variant-picker]', box);
    var addBtn = $('[data-add-button]', box);
    var addLabel = $('[data-add-label]', box);
    var errorEl = $('[data-form-error]', box);
    var galleryEl = $('[data-gallery]', box);
    var gallery = galleryEl ? initGallery(galleryEl) : null;

    // La barra fija es hermana del bloque (fuera del grid), dentro de la misma sección.
    var sectionEl = box.closest('.shopify-section') || box.parentNode;
    var sticky = $('[data-sticky-buy]', sectionEl);

    function selectedOptions() {
      return $$('fieldset', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function updateAvailability(options) {
      $$('fieldset', picker).forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var available = variants.some(function (v) {
            if (!v.available || v.options[index] !== input.value) return false;
            for (var j = 0; j < options.length; j++) {
              if (j !== index && v.options[j] !== options[j]) return false;
            }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
        var legendValue = $('[data-selected-value]', fs);
        if (legendValue) legendValue.textContent = options[index] || '';
      });
    }

    function setButtons(variant) {
      var disabled = !variant || !variant.available;
      var text = !variant ? theme.strings.unavailable : (variant.available ? theme.strings.addToCart : theme.strings.soldOut);
      if (addBtn) addBtn.disabled = disabled;
      if (addLabel) addLabel.textContent = text;
      if (sticky) {
        var sBtn = $('[data-sticky-add]', sticky);
        if (sBtn) sBtn.disabled = disabled;
      }
    }

    function updatePrice(variant) {
      if (!variant) return;
      var current = $('[data-price-current]', box);
      var compare = $('[data-price-compare]', box);
      var wrap = $('[data-price]', box);
      if (current) current.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) {
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
      }
      if (wrap) wrap.classList.toggle('price--sale', !!onSale);
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky);
        var sv = $('[data-sticky-variant]', sticky);
        if (sp) sp.textContent = formatMoney(variant.price);
        if (sv) sv.textContent = variant.title;
      }
    }

    function onVariantChange(e) {
      var userChange = !!e;
      var options = selectedOptions();
      var variant = findVariant(options);
      updateAvailability(options);
      setButtons(variant);
      if (errorEl) errorEl.hidden = true;
      if (!variant) return;
      idInput.value = variant.id;
      updatePrice(variant);
      // Al cargar, Liquid ya muestra la galería correcta; solo la movemos cuando el cliente elige.
      if (userChange && variant.featured_media && gallery) gallery.goTo(variant.featured_media.id, true);
      if (!userChange && theme.isProductPage && variant.featured_media && gallery) {
        var mediaId = variant.featured_media.id;
        var jump = function () { gallery.goTo(mediaId, false); };
        if (document.readyState === 'complete') jump(); else window.addEventListener('load', jump, { once: true });
      }
      if (userChange && theme.isProductPage && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker && variants.length) {
      picker.addEventListener('change', onVariantChange);
      // Sincroniza el estado inicial (p. ej. si el navegador restauró otra selección).
      onVariantChange();
    }

    // Cantidad
    $$('[data-qty-step]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('input');
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, Math.min(99, next));
      });
    });

    // Añadir al carrito (carrito lateral). Con "página de carrito" se deja el envío nativo.
    form.addEventListener('submit', function (e) {
      if (theme.cartType !== 'drawer' || !window.fetch || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      var submitter = e.submitter || addBtn;
      if (submitter && submitter.disabled) return;
      if (submitter) { submitter.classList.add('is-loading'); submitter.setAttribute('aria-disabled', 'true'); }
      if (errorEl) errorEl.hidden = true;

      var data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);

      fetchJSON(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: data
      }).then(function (res) {
        if (res.sections && res.sections['cart-drawer']) {
          CartDrawer.render(res.sections['cart-drawer']);
          CartDrawer.open(submitter);
        } else {
          CartDrawer.refresh().then(function () { CartDrawer.open(submitter); });
        }
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      }).finally(function () {
        if (submitter) { submitter.classList.remove('is-loading'); submitter.removeAttribute('aria-disabled'); }
      });
    });

    // Barra fija (móvil)
    if (sticky) initSticky(sticky, box);
  }

  function initSticky(sticky, box) {
    var target = $('[data-buy-buttons]', box) || box;
    var targetVisible = true;
    sticky.hidden = false;

    function update() {
      var show = !targetVisible && window.scrollY > 500;
      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-buy', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        targetVisible = entries[0].isIntersecting;
        update();
      }).observe(target);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();

    var info = $('[data-sticky-scroll]', sticky);
    if (info) {
      info.addEventListener('click', function () {
        var picker = $('[data-variant-picker]', box) || box;
        picker.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Carrito lateral ---------- */
  var CartDrawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && self.el && theme.cartType === 'drawer') {
          e.preventDefault();
          self.open(opener);
          return;
        }
        if (!self.el) return;
        if (e.target.closest('[data-cart-close]')) { self.close(); return; }

        var remove = e.target.closest('[data-line-remove]');
        if (remove && self.el.contains(remove)) {
          e.preventDefault();
          var line = remove.closest('[data-line]');
          self.change(line.getAttribute('data-line'), 0);
          return;
        }
        var step = e.target.closest('[data-line-step]');
        if (step && self.el.contains(step)) {
          var row = step.closest('[data-line]');
          var input = $('[data-line-qty]', row);
          var qty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-line-step'), 10));
          self.change(row.getAttribute('data-line'), qty);
        }
      });

      document.addEventListener('change', function (e) {
        if (!self.el || !self.el.contains(e.target) || !e.target.matches('[data-line-qty]')) return;
        var row = e.target.closest('[data-line]');
        self.change(row.getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
      });

      document.addEventListener('keydown', function (e) {
        if (!self.el || !self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'Tab') self.trapFocus(e);
      });
    },

    open: function (trigger) {
      if (!this.el) return;
      this.lastFocus = trigger || document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var panel = $('.drawer__panel', this.el);
      setTimeout(function () { panel.focus(); }, 50);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    trapFocus: function (e) {
      var focusables = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', this.el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.drawer__panel', this.el))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    },

    render: function (html) {
      if (!this.el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]', this.el);
      if (fresh && current) current.parentNode.replaceChild(fresh, current);
      updateCount(fresh ? fresh.getAttribute('data-count') : null);
    },

    refresh: function () {
      var self = this;
      return fetch(theme.routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { if (data['cart-drawer']) self.render(data['cart-drawer']); });
    },

    change: function (line, quantity) {
      var self = this;
      self.el.classList.add('is-loading');
      fetchJSON(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: parseInt(line, 10),
          quantity: quantity,
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      }).then(function (res) {
        if (res.sections && res.sections['cart-drawer']) self.render(res.sections['cart-drawer']);
        else return self.refresh();
      }).catch(function (err) {
        toast(err.message);
        return self.refresh();
      }).finally(function () {
        self.el.classList.remove('is-loading');
      });
    }
  };

  function updateCount(count) {
    if (count === null || count === undefined) return;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = parseInt(count, 10) === 0;
    });
  }

  /* ---------- Página del carrito ---------- */
  function initCartPage() {
    var form = $('[data-cart-page]');
    if (!form) return;
    var busy = false;

    function change(line, qty) {
      if (busy) return;
      busy = true;
      form.style.opacity = '.6';
      fetchJSON(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function () {
        window.location.reload();
      }).catch(function (err) {
        toast(err.message);
        busy = false;
        form.style.opacity = '';
      });
    }

    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-line-step]');
      if (!step) return;
      var row = step.closest('[data-line]');
      var input = $('[data-line-qty]', row);
      change(row.getAttribute('data-line'), Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-line-step'), 10)));
    });
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      var row = e.target.closest('[data-line]');
      change(row.getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------- Recomendaciones (productos relacionados) ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      var url = el.getAttribute('data-url');
      if (!url || url.indexOf('product_id=&') !== -1) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- Entrada suave al hacer scroll ---------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var targets = $$('.section-head, .benefit, .step, .mosaic__item, .split__media, .split__copy, .faq__item, .mood__copy');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t) {
      // Solo animamos lo que aún no está en pantalla, para no provocar saltos al cargar.
      if (t.getBoundingClientRect().top > window.innerHeight) {
        t.classList.add('reveal');
        io.observe(t);
      }
    });
  }

  /* ---------- Arranque ---------- */
  function init() {
    initAnnouncement();
    initMobileMenu();
    CartDrawer.init();
    $$('[data-buy-box]').forEach(initBuyBox);
    initCartPage();
    initRecommendations();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: reinicia los bloques de compra cuando se recarga una sección.
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-buy-box]', e.target).forEach(initBuyBox);
    if (e.target.querySelector('[data-cart-drawer]')) CartDrawer.el = $('[data-cart-drawer]');
  });
})();
